import React from 'react';
import { ArrowDownComponent } from './arrowDownComponent';

export const ThreeArrowDownComponent = () => {
	return (
		<>
			<div className={'flex flex-col'}>
				<div className={'-mt-9 animate-[bounce_1s_infinite_200ms]'}>
					<ArrowDownComponent />
				</div>
				<div className={'-mt-9 animate-[bounce_1s_infinite_100ms]'}>
					<ArrowDownComponent />
				</div>
				<div className={'-mt-9 animate-[bounce_1s_infinite_0ms]'}>
					<ArrowDownComponent />
				</div>
			</div>
		</>
	);
};
